var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LeliLogo"},[_c('img',{staticClass:"crown",attrs:{"src":_vm.crown,"alt":"crown"}}),_c('div',{staticClass:"words_box"},_vm._l((_vm.words),function(item,index){return _c('img',{key:index,class:`words words_${index + 1}`,attrs:{"src":item,"alt":"words"}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }